@if (client) {
  <span>{{ client ? clientToString(client) : '-' }}</span>
  @if (client.isRegisteredInPortal) {
    <nz-icon nzType="global" nzTheme="outline" class="ml-2" />
  }
} @else {
  {{ '-' }}
}
